export default async (axios, searchValue, page, limit, params = {}) => {
    const response = await axios.post('/Company/GetCompanyListingForManagement', {
        pageIndex: page,
        pageSize: limit,
        info: '',
        orderBy: ['name', 'asc'],
        category: '',
        document: '',
        phoneNumber: '',
        internalAddress: '',
        name: searchValue || '',
    });

    const { data } = response;

    return {
        metadata: {
            page: data.pageIndex,
            pages: Math.ceil(data.total / data.pageSize),
        },
        result: data.resultList.map(item => ({
            label: item.name,
            key: item.id,
            item,
        })),
    };
};
